<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import BottomNav from './components/BottomNav.vue'
import { useAuthStore } from './stores/auth'

const route = useRoute()
const auth = useAuthStore()
onMounted(() => auth.authenticated && auth.loadProfile().catch(() => undefined))
</script>

<template>
  <div class="app-shell">
    <div class="ambient ambient-one" aria-hidden="true" />
    <div class="ambient ambient-two" aria-hidden="true" />
    <main id="main-content" class="page" tabindex="-1">
      <RouterView />
    </main>
    <BottomNav v-if="!route.meta.hideNav" />
  </div>
</template>

